import { MouseEventHandler, useCallback } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { toggleMuteAction } from '../../../../pages/call/features/device/slice';
import { hasRolePermission } from '../../../../pages/call/features/permissions';
import { getParticipantRole } from '../../../../pages/call/features/permissions/helpers';
import { getParticipantById, selectIsPermissionsExtendedEnabled } from '../../../../pages/call/selectors';
import { SELF } from '../../../constants';
import { RolePermission } from '../../../helpers/permissions';
import { mutePeerAudio } from '../slice';

const useModerationParticipantAudio = (id: string) => {
    const dispatch = useDispatch();
    const participant = useSelector((state) => getParticipantById(state, id));
    const role = getParticipantRole(participant);
    const isPermissionsExtendedEnabled = useSelector(selectIsPermissionsExtendedEnabled);
    const hasMicrophonePermission = useSelector((state) => hasRolePermission(state, RolePermission.MICROPHONE, role));

    const isMe = id === SELF;
    const isMutedTrack = !participant?.audio || participant?.audio.muted;

    const muteParticipant = useCallback<MouseEventHandler>(
        (event) => {
            event.stopPropagation();
            dispatch(isMe ? toggleMuteAction({ type: 'audio' }) : mutePeerAudio(id));
        },
        [id, dispatch, isMe]
    );

    return {
        disableMicrophoneButton: (isMutedTrack && !isMe) || (isPermissionsExtendedEnabled && !hasMicrophonePermission),
        muteParticipant,
        isMutedTrack,
        hasMicrophonePermission,
    };
};

export default useModerationParticipantAudio;
